import '@/styles/hi-bg-scene.css'

type HiBgSceneProps = {
  /** No Carreiras usa fixed fullscreen; no login fica absolute no painel. */
  fixed?: boolean
}

/** Fundo animado Grupo HI (Carreiras / Login). */
export function HiBgScene({ fixed = true }: HiBgSceneProps) {
  const pos = fixed ? 'fixed inset-0 z-[0]' : 'absolute inset-0 z-0'
  return (
    <div className={`cr-bg-scene ${pos} pointer-events-none`} aria-hidden="true">
      <div className="cr-bg-base" />
      <div className="cr-bg-mesh" />
      <div className="cr-bg-orb cr-bg-orb-a" />
      <div className="cr-bg-orb cr-bg-orb-b" />
      <div className="cr-bg-orb cr-bg-orb-c" />
      <div className="cr-bg-beam cr-bg-beam-a" />
      <div className="cr-bg-beam cr-bg-beam-b" />
      <div className="cr-bg-grid" />
      <div className="cr-bg-particles">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className="cr-bg-veil" />
    </div>
  )
}
